<template>
    <div>
        <div class="row">
            <div class="col-12">
                <g-table-sync
                    :app="app"
                    :view="view"
                    :columns="columns"
                    :default-limit="20"
                    pagination="loadmore"
                    @edit="openForm"
                >
                    <template
                        slot="article"
                        slot-scope="{item}"
                    >
                        <span>{{ item.article.name }}</span>
                    </template>

                    <template
                        slot="rate"
                        slot-scope="{item}"
                    >
                        <span>{{ item.rate ? item.rate.text : '' }}</span>
                    </template>

                    <template
                        slot="pvp"
                        slot-scope="{item}"
                    >
                        <span>{{ item.pvp ? item.pvp + ' €' : '' }}</span>
                    </template>

                    <template
                        slot="pvd"
                        slot-scope="{item}"
                    >
                        <span>{{ item.pvd ? item.pvd + ' €' : '' }}</span>
                    </template>

                    <template
                        slot="discount"
                        slot-scope="{item}"
                    >
                        <span>{{ item.discount ? item.discount + ' %' : '' }}</span>
                    </template>
                </g-table-sync>
            </div>
        </div>

        <custom-form
            :id="id"
            ref="form"
            :visible="formEnabled"
            @close="closeForm"
        />
    </div>
</template>

<script>
import customForm from './form';

export default {
    name: 'RatePrices',
    components: { customForm },
    data() {
        return {
            app: 'prices',
            view: 'ratePricesList',
            columns: [
                {
                    title: 'Artículo',
                    index: 'article',
                    order: true,
                    slot: 'article'
                },
                {
                    title: 'Tarifa',
                    index: 'rate',
                    order: true,
                    slot: 'rate'
                },
                {
                    title: 'PVP',
                    index: 'pvp',
                    order: true,
                    slot: 'pvp'
                },
                {
                    title: 'PVD',
                    index: 'pvd',
                    order: true,
                    slot: 'pvd'
                },
                {
                    title: 'Descuento',
                    index: 'discount',
                    order: true,
                    slot: 'discount'
                },
                {
                    title: 'Acciones',
                    width: '190px',
                    slot: '_actions'
                }
            ],
            formEnabled: false,
            id: 0
        };
    },
    created() {
        this.$hub.$on('newPriceRate', () => {
            this.id = 0;
            this.formEnabled = true;
        });
    },
    beforeDestroy() {
        this.$hub.$off('newPriceRate');
    },
    methods: {
        openForm(item) {
            this.id = item._EntityId;
            this.formEnabled = true;
        },
        closeForm() {
            this.id = 0;
            this.formEnabled = false;
        }
    }
};
</script>

<style lang="scss">
</style>
